import { JointShape } from '@/modules/ConfiguratorJoints/composables/useShapeAndAngle';
import { JointCanvasTemplateConfiguration } from '@/modules/ConfiguratorJoints/types/canvasTemplate';
import {
    baseExternalCanvasTemplate,
    baseInternalCanvasTemplate,
} from '@/modules/ConfiguratorJoints/helpers/baseTemplateConfig';

export const externalCanvasTemplate: JointCanvasTemplateConfiguration = baseExternalCanvasTemplate;
export const internalCanvasTemplate: JointCanvasTemplateConfiguration = baseInternalCanvasTemplate;

export const heroJointCanvasTemplate: Record<JointShape, JointCanvasTemplateConfiguration> = {
    external: externalCanvasTemplate,
    internal: internalCanvasTemplate,
};
